import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { TaskManagerView } from "@/components/tasks/TaskManagerView";
import { useTasks } from "@/hooks/useTasks";
import { useTaskWrites } from "@/hooks/useTaskWrites";

export const Route = createFileRoute("/_authenticated/tasks")({
  component: TasksRoute,
});

/**
 * The Tasks surface — the user's Praxis-backed tasks (current /
 * waiting-on-you / completed), projected from beads server-side. Reads
 * via `useTasks`; writes relay through `useTaskWrites` (the intent-relay
 * channel — the agent's praxis CLI stays the sole bead writer). The
 * route stays thin: compose the two hooks, thread props.
 */
function TasksRoute() {
  const { current, held, completed, isLoading } = useTasks();
  const {
    completeTask,
    captureTask,
    resolveDecision,
    pendingByTaskId,
    pendingCaptures,
    errorByTaskId,
    captureError,
  } = useTaskWrites();
  const navigate = useNavigate();
  return (
    <div className="min-h-[calc(100vh-3.5rem)] bg-home-cream px-4 py-8 font-body text-home-ink md:py-10 lg:min-h-screen dark:bg-surface-dark dark:text-white">
      <TaskManagerView
        current={current}
        held={held}
        completed={completed}
        isLoading={isLoading}
        onOpenTask={(id) =>
          void navigate({ to: "/tasks/$taskId", params: { taskId: id } })
        }
        onCompleteTask={(id) => void completeTask({ taskId: id })}
        onResolveDecision={(id, answer) =>
          void resolveDecision({ taskId: id, answer })
        }
        onCapture={(text) => captureTask({ text })}
        pendingByTaskId={pendingByTaskId}
        pendingCaptures={pendingCaptures}
        errorByTaskId={errorByTaskId}
        captureError={captureError}
      />
    </div>
  );
}
